define([
    "jquery", 
    "wcs.product-views-util"], 
    function($, viewUtil){

var _swatchPosition = null,
    _swatchContainerHeight = null;

function expandMoreSwatches() {
    var attrBoxWidths = 0;
    
    if( $('.show-more-js').hasClass('expanded') ){
        return false;
    }
    
    $('.collapsable-container-js').not( $('.stl-product-grid-product-js .collapsable-container-js')).find('.attr-box').each(function(index) {
        attrBoxWidths += $(this).outerWidth(true);
        if ($(this).hasClass('selected')) {
            return false;
        }
    });

    if (attrBoxWidths > $('.collapsable-container-js').not($('.stl-product-grid-product-js .collapsable-container-js')).width() ||
        WCS_CONFIG.get('PDP::pdpColorSwatchesExpandedByDefault') === true) {
        $('.show-more-js').trigger('click');
    }
}

function initShowMoreColorsLink(){
    var $container          = $('.collapsable-container-js').not( $('.stl-product-grid-product-js .collapsable-container-js')),
         $swatches          = $container.find('.attr-box'),
         totalSwatches      = $swatches.length,
         width              = $swatches.outerWidth(true),
         containerMaxWidth  = $container.outerWidth(),
         swatchesPerRow     = Math.floor(containerMaxWidth / width),
         totalRows          = Math.ceil(totalSwatches / swatchesPerRow);

    if (totalRows === 0) {
        return;
    } else if (totalRows === 1) {
        viewUtil.pdpUpdatePage.toggleVisibility( $('.show-more-js'), false);
    } else {
        viewUtil.pdpUpdatePage.toggleVisibility( $('.show-more-js'), true);
    }
}

function initShowMoreColorsAsSwatch(){
    if(_swatchPosition == 'last'){
        return;
    }

    var $container = $('.collapsable-container-js'),
        $showMoreBtn = $('.color-swatches-action-js'),
        $swatch = $container.find('.attr-box'),
        totalSwatches = $swatch.length,  //Added one as we have More button as swatch.
        width = $swatch.outerWidth(true),
        containerMaxWidth = $container.outerWidth(),
        swatchesPerRow = Math.floor(containerMaxWidth / width),
        totalRows = Math.ceil(totalSwatches / swatchesPerRow);

    _swatchContainerHeight = $swatch.outerHeight(true);
    
    $container.height(_swatchContainerHeight);

    if (totalRows === 0) {
        return;
    } else if (totalRows === 1) {
        $showMoreBtn.css('display', 'none');
    } else {
        $lastElementInFirstRow = $($('.attr-box', $container).get(swatchesPerRow - 2));
        inputId = $lastElementInFirstRow.data ('formButton');
        $showMoreBtn.css('display', 'inline-block');
        $('.attr-box[data-form-button="' + inputId + '"]').after ($showMoreBtn);
    }
}

function showMoreSwatchesIfRoom() {
    var isDrawerLayout = (typeof SHOWMORELINKASSWATCH !== "undefined" && SHOWMORELINKASSWATCH);

    if (isDrawerLayout) {
        initShowMoreColorsAsSwatch();
        showMoreColorAsSwatches();
    }
    else {
        initShowMoreColorsLink();
        showMoreSwatches();
    }
}

var createVideoSwatch = ( function(){

    var self = {};

    self.init = function(videoType){
        var $videoSwatches,
            videoHtml;

        if (videoType === 'marketing') {
            $videoSwatches = $('.btn-marketing-video-js');
        }
        else if (videoType === 'product') {
            $videoSwatches = $('.product-videos-js');
        }

        videoHtml = self.setVideoSwatchHtml(videoType, $videoSwatches) || '';
        
        return videoHtml;
    };

    self.setVideoSwatchHtml = function(videoType, $videoSwatches){
        var videoHtml;

        if ($videoSwatches.length) {

            if (videoType === 'marketing') {
                videoHtml = $('.marketing-video-js', $videoSwatches)
                                .removeClass('hide')
                                .html();
            }
            else if (videoType === 'product') {
                videoHtml = $videoSwatches.html();
            }

        }

        return videoHtml;
    };

    return self.init;

}());

var showMoreColorAsSwatches = ( function(){

    var self = {};

    self.init = function(){
        self.bindClick();
    };

    self.bindClick = function(){
        $('.show-more-js', '.color-swatches-action-js').on('click', function(event){
            self.resizeContainerForColorSwatches(event);
        });
    };

    self.resizeContainerForColorSwatches = function(event){
        event.preventDefault();
           
            var $target             = $(event.target),
                altText             = $target.attr('data-alt-toggle-text'),
                $container          = $('.collapsable-container-js'),
                $showMoreBtn        = $('.color-swatches-action-js'),
                $swatch             = $container.find('.attr-box'),
                totalSwatches       = $swatch.length + $showMoreBtn.length, 
                width               = $swatch.outerWidth(true),
                containerMaxWidth   = $container.outerWidth(),
                swatchesPerRow      = Math.floor(containerMaxWidth / width),
                totalRows           = Math.ceil(totalSwatches / swatchesPerRow),
                swatchesInLastRow   = totalSwatches % totalRows,
                containerMaxHeight  = totalRows * _swatchContainerHeight,
                $lastElementInFirstRow,
                inputId,
                $lastSwatch;

            $target.attr('data-alt-toggle-text', $target.html()).html(altText);

            if ($container.height() >= containerMaxHeight) {
                $lastElementInFirstRow = $($('.attr-box', $container).get(swatchesPerRow - 2));
                inputId = $lastElementInFirstRow.data ('formButton');

                containerMaxHeight = _swatchContainerHeight;

                $('.attr-box[data-form-button="' + inputId + '"]').after($showMoreBtn);

                _swatchPosition = null;
             }
             else {
                $lastSwatch = $($('.attr-box', $container)).last();
                inputId = $lastSwatch.data ('formButton');

                $('.attr-box[data-form-button="' + inputId + '"]').after ($showMoreBtn);

                _swatchPosition = 'last';
             }

            $container.animate({
                height: containerMaxHeight
            }, 500);
    };

    return self.init;

}());

var showMoreSwatches = ( function(){

    var self = {};

    self.init = function(){
        self.bindClick();
    };
    
    self.bindClick = function(){
        $('.show-more-js').off().on('click', function(event){
            self.resizeContainerForSwatches(event);
        });
    };

    self.resizeContainerForSwatches = function(event){
        event.preventDefault();
        event.stopPropagation();
        
        var $container = $('.collapsable-container-js').not( $('.stl-product-grid-product-js .collapsable-container-js')),
            height = $container.find('.attr-box:first').outerHeight(true),
            width = $container.find('.attr-box:first').outerWidth(true),
            totalSwatches = $container.find('.attr-box').length,
            containerMaxWidth = $container.outerWidth(),
            swatchesPerRow = Math.floor(containerMaxWidth / width),
            totalRows = Math.ceil(totalSwatches / swatchesPerRow),
            containerMaxHeight = totalRows * height;
        
        if ($container.height() >= containerMaxHeight){
            containerMaxHeight = height;
        }
        $container.animate({
            height: containerMaxHeight+1
        }, 500);
        
        var altText = $(event.target).data('alt-toggle-text'),
            swatchText = $(event.target).text();

        if(typeof altText !== 'undefined' && typeof swatchText !== 'undefined') {
            $(event.target).data('alt-toggle-text', swatchText).text(altText);
        }
        $(event.target).toggleClass("expanded");
    };

    return self.init;

}());

var pdpAndQuickViewInitialSetup = ( function(){

    var self = {};

    self.init = function(){
        showMoreSwatchesIfRoom();
        expandMoreSwatches();
    };

    return self.init;

}());

return {
    pdpAndQuickViewInitialSetup : pdpAndQuickViewInitialSetup,
    showMoreSwatches : showMoreSwatches,
    expandMoreSwatches : expandMoreSwatches,
    showMoreSwatchesIfRoom : showMoreSwatchesIfRoom,
    createVideoSwatch : createVideoSwatch,
    initShowMoreColorsAsSwatch : initShowMoreColorsAsSwatch,
    showMoreColorAsSwatches : showMoreColorAsSwatches,
    initShowMoreColorsLink : initShowMoreColorsLink
};

});
